import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { apolloProvider } from './vue-apollo'
import mixins from './mixins'
import directives from './directives'
import globalComponents from './components/global'
import editorFieldsComponents from './components/editor/fields'
import vueFilterPrettyBytes from 'vue-filter-pretty-bytes'

Vue.config.productionTip = false

Vue.use(vueFilterPrettyBytes)

// Register mixins
Vue.mixin(mixins)

// Register directives
Object.entries(directives).forEach(([key, value]) => {
  Vue.directive(key, value)
})

// Register global components
Object.entries(globalComponents).forEach(([key, value]) => {
  Vue.component(key, value)
})

// Register editor fields components
Object.entries(editorFieldsComponents).forEach(([key, value]) => {
  Vue.component(key, value)
})

new Vue({
  router,
  store,
  vuetify,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
